import { render, staticRenderFns } from "./ImportDetails.vue?vue&type=template&id=3ff54e51&scoped=true&"
import script from "./ImportDetails.vue?vue&type=script&lang=js&"
export * from "./ImportDetails.vue?vue&type=script&lang=js&"
import style0 from "./ImportDetails.vue?vue&type=style&index=0&id=3ff54e51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff54e51",
  null
  
)

export default component.exports